<template>
  <section class="service">
    <div class="row">
      <div class="col-md-12"></div>
    </div>
   <div class="container animated slow fadeIn">
  <div class="row">
    <div class="col-md-12">
      <div class="maincontent">
        <div class="row">
          <div class="col-md-12 mt-5">
            <h1>Наши контакты</h1>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12"><hr /></div>
        </div>

        <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Отдел оптовых продаж:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div>
          <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ольга Климович</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375295864105">+375 29 586-41-05</a>
                <a class="tg" title="Telegram" href="https://t.me/VolhaKlimovich" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>401</p></div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Татьяна Деревянко</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375292755804">+375 29 275-58-04</a>
                <a class="tg" title="Telegram" href="https://t.me/tanka18" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>403</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Анна Тумилович</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375297719583">+375 29 771-95-83</a>
                <a class="tg" title="Telegram" href="https://t.me/AnnaTumilovich" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>405</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ольга Кулиш</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375292171994">+375 29 217-19-94</a>
                <a class="tg" title="Telegram" href="https://t.me/KulischOlga" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>406</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Брестский филиал:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ирина Лицкевич</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375297936545">+375 29 793-65-45</a>
                <a class="viber" title="Viber" href="viber://chat?number=+375447361425" target="_blank"></a><a class="tg" title="Telegram" href="https://t.me/OlgaOrdaBelca" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>421</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Гомельский филиал:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>

          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Алла Бандюк</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375291677543">+375 29 167-75-43</a>
                <a class="viber" title="Viber" href="viber://chat?number=+375447361383" target="_blank"></a><a class="tg" title="Telegram" href="https://t.me/annanikonov" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>423</p></div>

            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Гродненский филиал:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Елена Менько</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375292080350">+375 29 208-03-50</a>
                <a class="viber" title="Viber" href="viber://chat?number=+375447361402" target="_blank"></a><a class="tg" title="Telegram" href="https://t.me/lenabelca" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>424</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Могилевский филиал:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ольга Антипова</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375296383090">+375 29 638-30-90</a>
                <a class="viber" title="Viber" href="viber://chat?number=+375447361362" target="_blank"></a><a class="tg" title="Telegram" href="https://t.me/OlgaAntipova82" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>426</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Отдел по работе с корпоративными клиентами:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Елена Ярошевич</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375295756279">+375 29 575-62-79</a>
                <a class="tg" title="Telegram" href="https://t.me/LenaYaroshevich" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>431</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ирма Шепилова</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375293057763">+375 29 305-77-63</a>
                <a class="tg" title="Telegram" href="https://t.me/Kseniya_Filipovich" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>432</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Офисные телефоны:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6 col-sm-offset-6 col-xs-offset-6 col-md-offset-0">
            <p class="visible-sm visible-xs hidden-md hidden-lg"><strong>Офисные телефоны:</strong></p><p><a class="tel" href="tel:+375173880765">+375 17 388-07-65</a></p><p><a class="tel" href="tel:+375173880766">+375 17 388-07-66</a></p><p><a class="tel" href="tel:+375255029090">+375 25 502-90-90</a></p><p><a class="tel" href="tel:+375291554400">+375 29 155-44-00</a></p><p><a class="tel" href="tel:+375297554554">+375 29 755-45-54</a></p><p><a class="tel" href="tel:+375257554400">+375 25 755-44-00</a></p></div>
          </div>
          <div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Отдел продаж ООО «ПроПринт»:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6"><p><strong>Контактный телефон:</strong></p></div>
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Внутренний номер:</strong></p></div>
          </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ирина Сяба</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375297667994">+375 29 766-79-94</a>

                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>410</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Светлана Усс</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375447361350">+375 44 736-13-50</a>
                <a class="tg" title="Telegram" href="https://t.me/Sveta_Uss" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>411</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ольга Карницкая</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375295749168">+375 29 574-91-68</a>
                <a class="tg" title="Telegram" href="https://t.me/OlgaKarnickaya" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>412</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Юлия Скачкова</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375447361447">+375 44 736-14-47</a>
                <a class="tg" title="Telegram" href="https://t.me/uliaska111" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>413</p></div>
            </div><div class="row">
              <div class="col-md-4 col-sm-6 col-xs-6"><p>Ольга Журавлевич</p></div>
              <div class="col-md-4 col-sm-6 col-xs-6">
                <p>
                  <a class="tel" href="tel:+375447361350">+375 44 736-13-50</a>
                <a class="tg" title="Telegram" href="https://t.me/OlgaZhuraulevich" target="_blank"></a>
                </p>
              </div>
              <div class="col-md-4 hidden-sm hidden-xs"><p>414</p></div>
            </div><div class="row">
            <div class="col-md-12"><hr /></div>
          </div><div class="row">
            <div class="col-md-4 hidden-sm hidden-xs"><p><strong>Офисные телефоны:</strong></p></div>
            <div class="col-md-4 col-sm-6 col-xs-6 col-sm-offset-6 col-xs-offset-6 col-md-offset-0">
            <p class="visible-sm visible-xs hidden-md hidden-lg"><strong>Офисные телефоны:</strong></p><p><a class="tel" href="tel:+74994040648">+7 (499) 404-06-48</a></p><p><a class="tel" href="tel:+74732030135">+7 (473) 203-01-35</a></p><p><a class="tel" href="tel:+74832320188">+7 (483) 232-01-88</a></p></div>
          </div>
          <div class="row">
            <div class="col-md-12"><hr /></div>
          </div>
    </div>
  </div>
  </div>
</div>
</section>
</template>

<script>
import {
  Btn,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Container,
  NumericInput,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody
} from 'mdbvue'
export default {
  name: 'Information',
  data () {
    return {
      showModal: false,
      showModalH: false,
      showModalS: false,
      showModalK: false
    }
  },
  methods: {
  },
  mounted () {
    this.$emit('chngai', 4)
  },
  components: {
    Btn,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Container,
    NumericInput,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody
  }
}

</script>
<style scoped>
a.viber{
  width:20px;
  height:20px;
  display:inline-block;
  background:url(../assets/viber.png) center center;
  background-size:100%;
  margin-left:5px;
  position:relative;
  top:5px;
}
a.tg{
  width:20px;
  height:20px;
  display:inline-block;
  background:url(../assets/tg.png) center center;
  background-size:100%;
  margin-left:5px;
  position:relative;
  top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue